import { useModulesGetModuleByModuleIdQuery } from '@app/services/auto-generated/modules'
import { Language } from '@types'

interface LanguagesModuleConfig {
  languages: Language[]
}

const useLanguages = () => {
  const { data, isLoading, isSuccess } = useModulesGetModuleByModuleIdQuery({
    moduleId: 'Languages',
  })

  const languages: Language[] = data ? (data.config as LanguagesModuleConfig).languages : []

  const getLanguageFromCode = (languageCode: string) => {
    const target = languages.find((lng) => lng.code === languageCode)
    return target
  }

  const enhanceLanguages = (languages: any[]) => {
    if (!isSuccess) {
      return []
    }
    return languages.map((lang: any) =>
      getLanguageFromCode(
        typeof lang === 'string' ? lang : (lang.language ?? lang.code ?? lang.language_code),
      ),
    )
  }

  return { languages, isLoading, getLanguageFromCode, enhanceLanguages }
}

export default useLanguages
